export default function CourseHero() {
  return (
    <section className="relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          alt="Soft airy eucalyptus leaves on pale background"
          className="w-full h-full object-cover"
          src="https://readdy.ai/api/search-image?query=Very%20soft%20pale%20white%20and%20light%20gray%20background%20with%20delicate%20airy%20eucalyptus%20leaves%20and%20fern%20branches%2C%20minimalist%20botanical%20composition%2C%20subtle%20watercolor%20style%2C%20gentle%20diffused%20light%2C%20calming%20wellness%20aesthetic%2C%20muted%20sage%20and%20soft%20silver%20tones%2C%20editorial%20photography%2C%20serene%20peaceful%20atmosphere&width=1600&height=900&seq=course-hero-02&orientation=landscape"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/20 to-white/50" />
      </div>

      <div className="relative max-w-6xl mx-auto px-6 md:px-12 pt-28 pb-20 md:pt-36 md:pb-28 text-center">
        <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase bg-[#6B8FA3]/15 text-[#2C3E6B] rounded-full mb-6 border border-[#6B8FA3]/25">
          Self-Paced Online Course
        </span>

        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 mb-5 leading-tight">
          The Energy Safe Journey
        </h1>

        <p className="text-lg md:text-xl text-foreground-800 mb-3 max-w-2xl mx-auto leading-relaxed">
          A Transformational Path &amp; a Structured Behaviour Change System
        </p>

        <p className="text-base md:text-lg text-foreground-600 mb-6 max-w-xl mx-auto italic">
          Protect your baseline. Eliminate the crash. Reclaim your day.
        </p>

        {/* Three groups */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-8 max-w-2xl mx-auto">
          <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-[#6B8FA3]/15 text-[#2C3E6B] border border-[#6B8FA3]/25 whitespace-nowrap">
            Chronic Illness
          </span>
          <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-[#6B8FA3]/15 text-[#2C3E6B] border border-[#6B8FA3]/25 whitespace-nowrap">
            ADHD &amp; Autism
          </span>
          <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-[#6B8FA3]/15 text-[#2C3E6B] border border-[#6B8FA3]/25 whitespace-nowrap">
            Life-Demand Mismatch
          </span>
        </div>

        {/* Price Badge */}
        <div className="inline-flex flex-col sm:flex-row items-center gap-3 sm:gap-5 bg-white/70 backdrop-blur-md rounded-xl px-6 py-4 border border-background-200 shadow-lg mb-8">
          <div className="text-center sm:text-left">
            <p className="text-xs text-foreground-500 uppercase tracking-wider mb-1">Special Launch Price</p>
            <div className="flex items-baseline gap-3 justify-center sm:justify-start">
              <span className="text-lg text-foreground-400 line-through">£197</span>
              <span className="text-3xl md:text-4xl font-bold text-foreground-950">£97</span>
            </div>
          </div>
          <div className="hidden sm:block w-px h-10 bg-background-300" />
          <div className="text-center sm:text-left">
            <p className="text-xs text-foreground-500 mb-1">5 Energy Paths</p>
            <p className="text-xs text-foreground-500">+ Practical PDF Tools &amp; Trackers</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://federica-tedeschi3.systeme.io/course"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#2C3E6B] text-white px-8 py-4 rounded-lg font-semibold text-base shadow-lg hover:bg-[#243A5C] hover:scale-[1.05] hover:-translate-y-[3px] hover:shadow-xl transition-all duration-300 ease-out whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-cart-line text-base" />
            </span>
            Enrol Now — £97
          </a>
          <a
            href="#whats-inside"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#whats-inside')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 border-2 border-[#6B8FA3] text-[#2C3E6B] px-8 py-4 rounded-lg font-medium text-base shadow-md hover:bg-[#6B8FA3]/10 hover:scale-[1.05] hover:-translate-y-[3px] hover:shadow-lg transition-all duration-300 ease-out whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-line text-base" />
            </span>
            Explore the Course
          </a>
        </div>
      </div>
    </section>
  );
}